// extracted by mini-css-extract-plugin
export default {"error":"c-a_am","error__title":"c-a_an","error__title_big":"c-a_ao","error__message":"c-a_ap"};